export default __webpack_public_path__ + "static/media/bg02.75729815.png";